// path '/auth/register', uses backend for Email with token for registration

export default {
	auth: 'auth',
	portal: 'portal',
};
